export const SET_IS_SEARCHABLE = 'classpass/searchmap/SET_IS_SEARCHABLE';
export const SET_POPUP = 'classpass/searchmap/SET_POPUP';
export const CLEAR_POPUP = 'classpass/searchmap/CLEAR_POPUP';
export const HIGHLIGHT_VENUE = 'classpass/searchmap/HIGHLIGHT_VENUE';
export const UNHIGHLIGHT_VENUE = 'classpass/searchmap/UNHIGHLIGHT_VENUE';
export const SET_VIEWPORT = 'classpass/searchmap/SET_VIEWPORT';
export const SET_MAP_LOADED = 'classpass/searchmap/SET_MAP_LOADED';

export const setPopup = popup => ({ type: SET_POPUP, key: 'popup', value: popup });
export const clearPopup = () => ({ type: CLEAR_POPUP, key: 'popup', value: {} });
export const setIsSearchable = isSearchable => ({ type: SET_IS_SEARCHABLE, key: 'isSearchable', value: isSearchable });
export const setViewport = viewport => ({ type: SET_VIEWPORT, key: 'viewport', value: viewport });
export const highlightVenue = venueId => ({ type: HIGHLIGHT_VENUE, venueId });
export const unhighlightVenue = () => ({ type: UNHIGHLIGHT_VENUE });
export const setMapLoaded = (isMapLoaded, options) => ({
  type: SET_MAP_LOADED,
  key: 'isMapLoaded',
  value: isMapLoaded,
  options,
});
export const selectSearchMapState = state => state.features.searchMap;
export const selectPopup = state => selectSearchMapState(state).popup;
export const selectIsSearchable = state => selectSearchMapState(state).isSearchable;
export const selectViewport = state => selectSearchMapState(state).viewport;
export const selectHighlightedVenueId = state => selectSearchMapState(state).highlightedVenueId;
export const selectIsMapLoaded = state => selectSearchMapState(state).isMapLoaded;

const initialState = {
  popup: {},
  isSearchable: false,
  highlightedVenueId: null,
  viewport: {},
  hasRadiusBeenCalculated: false,
  isMapLoaded: false,
};

export function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_IS_SEARCHABLE:
    case SET_POPUP:
    case CLEAR_POPUP:
    case SET_MAP_LOADED:
    case SET_VIEWPORT:
      return {
        ...state,
        [action.key]: action.value,
      };
    case HIGHLIGHT_VENUE:
      return {
        ...state,
        highlightedVenueId: action.venueId,
      };
    case UNHIGHLIGHT_VENUE:
      return {
        ...state,
        highlightedVenueId: null,
      };
    default:
      return state;
  }
}
